import './InGameHeader.css'

/**
 * 
 * @param {{
 *  brandLogo: string;
 *  title: string;
 *  subtitle: string;
 * }} param0 
 * @returns 
 */
export default function InGameHeader({
    brandLogo,
    title,
    subtitle
}) {
    return (
        <div className="bg-yellow rounded-xl p brown-shadow">
            <div className='p-1 bg-orange rounded-xl relative overflow-hidden'>

                {/* Blinking lights for the in-game header */}
                <div className="in-game-lights w-full" style={{ top: -6, right: 6, height: 15, }} />
                <div className="in-game-lights w-full" style={{ bottom: -1, right: 6, height: 15, }} />
                <div className="in-game-lights h-full" style={{ width: 15, left: -6 }} />
                <div className="in-game-lights h-full" style={{ width: 15, right: -1 }} />
                {/* End of blinking lights */}

                <div className="bg-gradient-yellow-gold rounded-lg flex items-center gap-2 p-1 relative z-2 in-game-content">
                    {brandLogo &&
                        <div className="overflow-hidden rounded-full border-2 border-brown in-game-brand-logo">
                            <img src={brandLogo} alt="brand_logo" className="w-full h-full object-contain" />
                        </div>
                    }
                    <div className="flex flex-col gap-1">
                        {title &&
                            <h1 className="in-game-header-title font-bold m-0 text-brown">{title}</h1>}
                        {subtitle &&
                            <p className="in-game-header-subtitle m-0 text-orange font-semibold uppercase letter-spacing-loose text-ellipsis in-game-subtitle-container" title={subtitle}>{subtitle}</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}